import { FC, useState } from 'react';

import { Box, HStack, PencilOutline, rem, Text } from '@bonusly/design-system';
import { CustomThemeModal } from '@bonusly/ds-theme';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { Reveal } from '../../../components/display/reveal';

interface CustomThemeMenuItemProps {
	isExpanded: boolean;
}

export const CustomThemeMenuItem: FC<CustomThemeMenuItemProps> = ({ isExpanded }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const company = useCurrentCompany();

	// Only show for Bonusly company users (internal feature)
	if (!company?.is_bonusly_company) {
		return null;
	}

	return (
		<>
			<Box
				as="button"
				display="block"
				onClick={() => setIsModalOpen(true)}
				w="100%"
				py={rem(8)}
				px={rem(10)}
				borderRadius="md"
				bg="none"
				color="secondary.fg"
				cursor="pointer"
				_hover={{ bg: 'secondary.bgAlpha' }}
				_active={{ bg: 'secondary.bgAlpha' }}
				data-testid="nav-link-customize-theme"
			>
				<HStack justifyContent={isExpanded ? 'flex-start' : 'center'} alignItems="center" spacing={3}>
					<Box display="flex" alignItems="center">
						<PencilOutline size="md" />
					</Box>
					<Reveal if={isExpanded}>
						<Text fontSize={100} fontWeight="medium" whiteSpace="nowrap">
							Preset Themes
						</Text>
					</Reveal>
				</HStack>
			</Box>
			<CustomThemeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
		</>
	);
};
